//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { openChat } from '@/data/im'
import callConsultant from '@/common/mixins/callConsultant'
import Service from '@/service/blog'
import HouseItem from '@/components/business/house_item'
export default {
    mixins: [
        callConsultant
    ],
    props: {
        show_delete: {
            type: Boolean,
            default: false
        },
        show_operate: {
            type: Boolean,
            default: true
        },
        item: {
            type: Object
        }
    },
    components: {
        HouseItem
    },
    methods: {
        getHtml(item) {
            let html
            let content = item.content
            if (item.tag_name && item.tag_name !== '其他') {
                html = `<span class="tag_name">${item.tag_name}</span>`
                content = html + item.content
            }
            
            return  content 
        },
        onCard () {
            if (!this.show_operate) {
                return
            }
            wx.navigateTo({
                url: `/pages/consultants/card/main?id=${this.item.author_details.consultant_id}`
            })
        },
        onChat () {
            openChat(this.item.author_details.consultant_id)
        },
        onFold () {
            this.item.fold = !this.item.fold
            this.$emit('changeFeed', this.item)
        },
        onPreview (index) {
            const { photos_urls } = this.item
            wx.previewImage({
                current: photos_urls[index],
                urls: photos_urls
            })
        },
        onDelete () {
            Service.delBlog(this.item.id).then(() => {
                wx.showToast({
                    title: '删除成功'
                })
                this.$emit('delete', this.item.id)
            })
        },
        onSticky () {
            if (!(this.show_delete && this.item.editable)) return 
            Service.stickyFeed(this.item.id).then((res) => {
                if (res.code === 422) {
                     wx.showToast({
                        title: res.error_message,
                        icon: 'none'
                    })               
                }
                if (!this.item.sticky) {
                    wx.showToast({
                        title: '置顶成功',
                        icon: 'none'
                    })                    
                }
                this.$emit('sticky', this.item.id)
            })
        }
    }
}
